import {
  getData,
  catchHttpError,
  extractContentsFromResponse,
} from "shared/api";
import apiRoutes from "startups/apiRoutes";
import { createActionSubmitter } from "shared/redux-store/defaults";
import routes from "startups/routes";

export function fetchOrderUnitEditor(id) {
  if (!id) {
    return { type: "FETCH_NOT" };
  }

  return dispatch =>
    dispatch({
      type: "FETCH_ORDER_UNIT_EDITOR",
      payload: Promise.all([getData(apiRoutes.orderUnitEditPath(id))]),
    }).catch(catchHttpError);
}

function successCallback(response, dispatch) {
  const orderUnitResourceId = Object.keys(
    extractContentsFromResponse(response, ["orderUnit"]).orderUnit,
  )[0];

  // TODO better solution to ensure redirect gets dispatched after fulfill…
  setTimeout(() => {
    dispatch({
      type: "REDIRECT",
      redirectTo: routes.startupsOrderUnitPath(orderUnitResourceId),
    });
  });
}

export const submitOrderUnitEditor = createActionSubmitter(
  "ORDER_UNIT_EDITOR",
  [
    {
      pathFn: apiRoutes.updateOrderUnitPath,
      verb: "PATCH",
    },
  ],
  successCallback,
);
